import React, { createRef, forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { useReactToPrint } from 'react-to-print'
//import useDetectPrint from 'use-detect-print'

import SalePrintableTicket from './SalePrintableTicket'

import { TicketType } from '../../utilities/constants'
//import { Impresora } from '../../assets/js/Impresora'

import styles from './SaleTicket.module.scss'
import { useAtom } from 'jotai'
import { idleDoneTimerPaused, bookingSessionTripConfig } from '../../utilities/atoms'
import { useLogger } from '../../contexts/logger.context'
import { currency } from '../../components/transpais/helpers/currency'
import { PassengerType, TicketService } from '../../components/transpais/enums'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { isSingleTrip } from '../../helpers/tripHelpers'
import { serializeElementForNativePrint, tryNativePrintHtml } from '../../utilities/voucherNativePrint'
import { useModal } from '../../contexts/modal.context'
import { recordFlightEvent } from '../../debug/flightRecorder'

const SaleTicket = forwardRef(({
                                 ticket,
                                 redondo,
                                 regreso,
                                 tripData,
                                 payment,
                                 confirmation,
                                 printable,
                                 ask,
                                 done,
                                 onClick
                               }, ref) => {

  const printableRef = createRef()
  //const isPrinting = false//useDetectPrint()
  const {loggerDebug, loggerError} = useLogger()
  const { showModal, hideModal, setupModal } = useModal()

  const [, setIdleDonePaused] = useAtom(idleDoneTimerPaused)
  const [printed, setPrinted] = useState(false)
  //const [selected, setSelected] = useState(false)

  const [tripConfig, ] = useAtom(bookingSessionTripConfig)

  const handlePrint = useReactToPrint({
    content: () => {
      loggerDebug('Content', printableRef, printableRef.current)
      return printableRef.current
    }, onBeforePrint: () => {
      recordFlightEvent('PRINT:DIALOG_BEFORE', { kind: 'ticket' }, 'SaleTicket.handlePrint')
      setIdleDonePaused(true)
    }, //removeAfterPrint: false,
    onAfterPrint: () => {
      recordFlightEvent('PRINT:DIALOG_AFTER', { kind: 'ticket' }, 'SaleTicket.handlePrint')
      //setIdlePaused(false)
      setIdleDonePaused(false)
      setPrinted(true)
      done()
    }, onPrintError: (errorLocation, error) => {
      recordFlightEvent('PRINT:DIALOG_ERROR', {
        kind: 'ticket',
        location: errorLocation,
        message: error instanceof Error ? error.message : String(error),
      }, 'SaleTicket.handlePrint')
      loggerError(errorLocation, error)
      setIdleDonePaused(false)
    }
  })

  const runNativeTicketPrint = async () => {
    const el = printableRef.current
    if (!el) {
      recordFlightEvent('PRINT:TICKET_NATIVE_SKIP', { code: 'EMPTY_DOM' }, 'SaleTicket.runNativeTicketPrint')
      return { ok: false, code: 'EMPTY_DOM' }
    }
    recordFlightEvent('PRINT:TICKET_SERIALIZE_START', { ticketId: ticket?._id || ticket?.itemId || null }, 'SaleTicket.runNativeTicketPrint')
    const serialized = await serializeElementForNativePrint(el, { baseHref: window.location.href })
    if (!serialized.ok) {
      recordFlightEvent('PRINT:TICKET_SERIALIZE_FAIL', { code: 'SERIALIZE_FAILED' }, 'SaleTicket.runNativeTicketPrint')
      return { ok: false, code: 'SERIALIZE_FAILED' }
    }
    return await tryNativePrintHtml(serialized.html, { type: 'ticket', baseHref: window.location.href })
  }

  const printTicketNativeOrManual = async () => {
    recordFlightEvent('PRINT:TICKET_FLOW_START', { ticketId: ticket?._id || ticket?.itemId || null }, 'SaleTicket.printTicketNativeOrManual')
    const r = await runNativeTicketPrint()
    if (r.ok) {
      recordFlightEvent('PRINT:TICKET_NATIVE_OK', { ticketId: ticket?._id || ticket?.itemId || null }, 'SaleTicket.printTicketNativeOrManual')
      setPrinted(true)
      done()
      return
    }

    if (r.code === 'DISABLED' || r.code === 'NO_ELECTRON_API' || r.code === 'CONFIG_ERROR') {
      recordFlightEvent('PRINT:TICKET_FALLBACK_DIALOG', { code: r.code }, 'SaleTicket.printTicketNativeOrManual')
      handlePrint()
      return
    }

    recordFlightEvent('PRINT:TICKET_RETRY_MODAL', { code: r.code, message: r.message }, 'SaleTicket.printTicketNativeOrManual')
    setupModal({
      title: 'Impresión',
      content: (
        <>
          <p>No se pudo imprimir el boleto en modo automático.</p>
          <p>Revisa impresora y configuración del kiosko, luego reintenta.</p>
        </>
      ),
      actions: {
        positive: {
          title: 'Reintentar',
          onClick: () => {
            hideModal()
            setTimeout(() => {
              void printTicketNativeOrManual()
            }, 0)
          },
        },
        negative: {
          title: 'Cancelar',
          onClick: () => hideModal(),
        },
      },
    })
    showModal()
  }

  useImperativeHandle(ref, () => ({
    printTicket() {
      void printTicketNativeOrManual()
    }
  }))

  const printTicket = () => {
    //loggerDebug('Printed', printed)
    //setIdlePaused(true)
    if (printed) {
      loggerDebug('Printed', 'ask')
      ask()
    } else {
      setPrinted(true)
      handlePrint()
    }
  }

  //const toggleSelection = () => {
  //setSelected(!selected)
  //}
  useEffect(() => {
    console.log(ticket)
  }, [])
// [styles.ticket, !false ? styles.selectable : null, !printable ? ticket.selected ? styles.selected : styles.unselected : null] origin styles conditions
  return (<div ref={ ref }>
    <div
      className={ [styles.ticket].join(' ') }
      onClick={ () => !printable ? onClick(ticket) : null } style={ {display: 'none'} }>
      <div className={ [styles.info, printable ? styles.small : null].join(' ') }>
        <div className={ styles.seat }>
          <h3>Asiento</h3>
          <p>{ ticket.seat ?? ticket.asiento }</p>
        </div>
        <div className={ styles.data }>
          <p className={ styles.name }>{ ticket ? ticket.pasajero : '-' }</p>
          { !printable && (<p className={ styles.type }>
            <svg className={ [styles.category, styles.icon].join(' ') }>
              <use xlinkHref={ `#${ TicketType.icon(ticket.tipo) }` }/>
            </svg>
            <span>{ TicketType.label(ticket.tipo) }</span>
            { !isSingleTrip(tripConfig) && ( <span className={ [styles.tag, !isSingleTrip(tripConfig) ? styles.return : null].join(' ') }>
              { tripData?.origin } › { tripData?.destination }
            </span> 
            )}
            { ticket.servicios.length > 0 ? ticket.servicios.map((servicio) => (
              <span key={ `t_${ ticket.id }_${ servicio.id }` } className={ styles.servicio }><FontAwesomeIcon
                icon={ TicketService.icon(servicio.nombre) }
                className={ styles.icon }/> <span>{ servicio.nombre }</span> <span>{ currency(servicio.precio) }</span></span>
            )) : null }
          </p>) }
        </div>
      </div>
      { !printable ? (<div className={ styles.precio }>
        <p>{ currency(ticket ? ticket.precio : 0) }</p>
        {/*<div className={ styles.selectWrapper }>*/ }
        {/*  <h3>Pagar</h3>*/ }
        {/*  <svg className={ [styles.icon].join(' ') }>*/ }
        {/*    <use xlinkHref={ `#${ !ticket.selected ? 'circle-dashed' : 'circle-check' }` }/>*/ }
        {/*  </svg>*/ }
        {/*</div>*/ }
      </div>) : (<div className={ styles.print } onClick={ printTicket }>
        <svg className={ [styles.icon, printed ? styles.done : null].join(' ') }>
          <use xlinkHref={ `#${ !printed ? 'print' : 'check' }` }/>
        </svg>
        <span>Imprimir</span>
      </div>) }
    </div>
    { printable && (<div /*style={ {display: 'none'} }*/><SalePrintableTicket ref={ printableRef } ticket={ ticket }
                                                                          payment={ payment }
                                                                          confirmation={ confirmation }/>
    </div>) }
  </div>)
})

export default SaleTicket
